import { render } from "./DeleteUser.vue?vue&type=template&id=153b256a"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=153b256a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__